// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"499":"2b4dc9d3","550":"632743db"}[chunkId] + "." + {"499":"0194cfc7c6b6abe5","550":"40056f0adb44d0c5"}[chunkId] + ".js";
};